import downloader from 'js-file-download'
import api from '@/apis'

export default {
  state: {
    visibility: false,
    audio_src: null,
    asr_result: null
  },
  mutations: {
    SET_ASR_RESULT_CARD_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_ASR_RESULT_CARD_RESULTS(state, payload) {
      state.audio_src = payload.audio_src
      state.asr_result = payload.asr_result
    },
    SET_ASR_RESULT_CARD_RESULTS_SEGMENT_TEXT(state, payload) {
      state.asr_result = payload.asr_result
    }
  },
  actions: {
    async downloadSubtitling({ commit }, payload) {
      try {
        const response = await api.downloadSubtitling(payload)
        if (response.status === 200 && response.data) {
          console.log(response.data)
          const header_content = response.headers['content-disposition']
          const filename = header_content.substring(header_content.indexOf('"') + 1, header_content.lastIndexOf('"'))

          downloader('\ufeff' + response.data, filename)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: 'Download Log', icon: 'check', timeout: '2000' })
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
